export const getAllTechnologiesQuery = `
query GetAllTechnologies {
    getAllTechnologies {
        id
        title
        description
        technologyItems {
            title
            description
            detailUrl
        }
    }
}
`;

export const addTechnologyQuery = `
mutation AddTechnology($input: CreateTechnologyInput!) {
    addTechnology(input: $input) {
        id
        title
        description
        technologyItems {
            title
            description
            detailUrl
        }
    }
}
`;

export const updateTechnologyQuery = `
mutation UpdateTechnology($input: UpdateTechnologyInput!) {
    updateTechnology(input: $input) {
        id
        title
        description
        technologyItems {
            title
            description
            detailUrl
        }
    }
}
`;

export const getTechnololgyByIdQuery = `
query GetTechnologyById($id: ID!) {
    getTechnologyById(id: $id) {
        id
        title
        description
        technologyItems {
            title
            description
            detailUrl
        }
    }
}
`;

export const deleteTechnologyQuery = `
mutation DeleteTechnology($id: ID!) {
    deleteTechnology(id: $id) {
        status
    }
}
`;
